export default {
  'employee.searchBar.button': 'Criar Novo Funcionário',
  'employee.list.header.name': 'Nome do Funcionário',
  'employee.list.header.gender': 'Gênero',
  'employee.list.header.registry': 'Registro',
  'employee.list.header.function': 'Função',
  'employee.list.header.contactType': 'Tipo de Contato',
  'employee.list.header.role': 'Cargo',
  'employee.list.header.email': 'e-mail',
  'employee.list.header.phone': 'Telefone',
  'employee.list.header.includedAt': 'Inclusão',
  'employee.list.header.actions': 'Ações',
  'employee.list.column.actions.button': 'Ver/Editar',
  'employee.filter.registry': 'Registro',
  'employee.filter.function': 'Função',
  'employee.filter.order': 'Ordem',
  'employee.create.notification.success': 'Sucesso',
  'employee.create.notification.successDescription':
    'Funcionário cadastrado com sucesso.',
  'employee.update': 'Atualizar Funcionário',
  'employee.update.notification.success': 'Sucesso',
  'employee.update.notification.successDescription': 'Funcionário atualizado.',
  'employee.create.notification.successDescription': 'Funcionário criado.',
  'employee.remove.modal.title': 'Excluír Funcionário',
  'employee.remove.modal.content': 'Você deseja excluír o funcionário',
  'employee.remove.modal.button.ok': 'Excluír',
  'employee.remove.notification.success': 'Sucesso',
  'employee.remove.notification.successDescription': 'Funcionário excluído.',
  'employee.personal.form.employeeName': 'Nome do Funcionário',
  'employee.personal.sexType': 'Sexo',
  'employee.personal.genderType.man': 'Masculino',
  'employee.personal.genderType.woman': 'Feminino',
  'employee.personal.form.cpf': 'CPF',
  'employee.personal.form.rg': 'RG',
  'employee.personal.form.birth': 'Nascimento',
  'employee.personal.form.birthday': 'Aniversário',
  'employee.personal.form.upUntil': 'Até',
  'employee.personal.form.phone1': 'Telefone 1 (00) 00000-0000',
  'employee.personal.form.phone2': 'Telefone 2 (00) 00000-0000',
  'employee.personal.form.companies': 'Empresas',
  'employee.personal.form.email': 'E-mail',
  'employee.personal.form.gender': 'Gênero',
  'employee.personal.form.cep': 'CEP',
  'employee.personal.form.uf': 'UF',
  'employee.personal.form.city': 'Cidade',
  'employee.personal.form.district': 'Bairro',
  'employee.personal.form.street': 'Logradouro',
  'employee.personal.form.number': 'Número',
  'employee.personal.form.complement': 'Complemento',
  'employee.personal.form.zone': 'Região',
  'employee.personal.form.upload': 'Adicionar imagem do perfil',
  'employee.personal.form.observation': 'Observações',
  'employee.professional.form.registry': 'Registro',
  'employee.professional.form.company': 'Empresa',
  'employee.professional.form.situation': 'Situação',
  'employee.professional.form.type': 'Tipo',
  'employee.professional.form.areas': 'Áreas',
  'employee.professional.form.academyLevel': 'Nível acadêmico',
  'employee.professional.form.role': 'Cargo',
  'employee.professional.form.occupation': 'Função',
  'employee.professional.form.email': 'E-mail',
  'employee.professional.form.admissionDate': 'Data de admissão',
  'employee.professional.form.workCard': 'Carteira de trabalho',
  'employee.professional.form.pis': 'Número do PIS',
  'employee.professional.form.salary': 'Salário',
  'employee.professional.form.pieceCommission': 'Comissão de peça (%)',
  'employee.professional.form.serviceCommission': 'Comissão de serviço (%)',
  'employee.professional.form.busLines': 'Linhas de ônibus',
  'employee.professional.form.ticketValue': 'Valor das passagens',
  'employee.professional.form.vehicleCode': 'Código da viatura',
  'employee.professional.form.observation': 'Observações',
  'employee.professional.form.estimator': 'É orçamentista/vendedor?',

  'employee.professional.success.message': 'Sucesso!',
  'employee.professional.success.description':
    'Dados profissionais salvo com sucesso',

  'employee.filters.active.options.all': 'Todos',
  'employee.filters.active.options.active': 'Ativo',
  'employee.filters.active.options.inactive': 'Inativo',
  'employee.modal.report.title': 'Gerar Relatório',
  'employee.modal.report.buttons.viewReport': 'Visualizar relatórios',
  'employee.modal.report.buttons.pdf': 'PDF',
  'employee.modal.report.buttons.csv': 'CSV',
  'employee.notification.generate.report.title':
    'Relatório gerado com sucesso!',
  'employee.notification.generate.report.description':
    'Relatório de Funcionários Gerado com Sucesso!',
  'employee.professional.form.contacts': 'Contatos',

  'employee.modal.report.form.upUntil': 'Até',
  'employee.modal.report.form.specificDate': 'Data Específica de Aniversário',

  'employee.cpfIncorrect.error': 'CPF digitado está incorreto!',
  'employee.cpfAlreadyExists':
    'Já existe um funcionário cadastrado com este CPF!',

  'employee.modal.selectedEmployees.title.add': 'Adicionar Funcionário',
  'employee.modal.selectedEmployees.search': 'Busque os funcionários',
};
